/**
 * Frame-rate facts shared by everything that has to agree on how long a clip
 * composition is.
 *
 * JSX-free and dependency-free for the same reason `layout.ts` is: these are
 * imported as *values* by `packages/server` (`renderChunk`'s `frameRange`
 * math), so pulling them out of a `.tsx` module would drag the layout registry
 * — and `lib: ["dom"]` — into a Node-only package's type graph.
 *
 * `FPS` is deliberately the one constant, not `render.config.fps`: the
 * compositions in `RemotionStudio` are registered at a fixed 30, so a config
 * value that disagreed would make `frameRange` address frames the composition
 * does not have.
 */
export const FPS = 30

/**
 * How many frames a clip scene of `durationSeconds` occupies.
 *
 * Floored at 1: Remotion rejects a zero-length composition, and a sub-frame
 * render (a 0.01 s selection) would otherwise produce `durationInFrames: 0`.
 */
export function clipSceneDurationInFrames(
  durationSeconds: number,
  fps: number = FPS,
): number {
  return Math.max(1, Math.round(durationSeconds * fps))
}
